import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import type { StackProps } from '@mui/material/Stack';
import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material/styles';

import { editorClasses } from '../../classes';
import type { EditorToolbarProps } from '../../types';
import { DropDownItem } from './DropDownItem';
import ToolbarBox from './ToolbarBox';
import { ToolbarItem } from './ToolbarItem';
import { getToolbarItems } from './config';
import icons from './icons';
import { containerSx, dividerSx } from './styles';
import { BoxType, ToolbarOptions } from './types';

export function Toolbar({
  sx,
  editor,
  fullItem,
  fullScreen,
  onToggleFullScreen,
  variables,
  toolbarConfig,
  ...other
}: StackProps & EditorToolbarProps) {
  if (!editor) {
    return null;
  }

  const boxStyles: SxProps<Theme> = {
    gap: 0.5,
    display: 'flex',
  };

  const toolbars: BoxType[] = [ToolbarOptions.TextStyle, ToolbarOptions.List, ToolbarOptions.Align];

  const toolbar = toolbarConfig || toolbars;

  const toolbarItems = getToolbarItems(editor);

  return (
    <Stack className={editorClasses.toolbar.root} sx={[containerSx, ...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      {toolbars.map((option) => (
        <ToolbarBox key={option} toolbarConfig={toolbar} boxType={option} editor={editor} toolbarItems={toolbarItems} />
      ))}
      <Divider orientation="vertical" flexItem sx={dividerSx} />
      <Box sx={{ ...boxStyles }}>
        <ToolbarItem
          aria-label="Fullscreen"
          active={fullScreen}
          className={editorClasses.toolbar.fullscreen}
          onClick={onToggleFullScreen}
          icon={<path d={fullScreen ? icons[ToolbarOptions.FullScreenOff] : icons[ToolbarOptions.FullScreenOn]} />}
        />
      </Box>
      {!!variables && !!variables.length && (
        <>
          <Divider orientation="vertical" flexItem sx={dividerSx} />
          <Box sx={{ ...boxStyles }}>
            <DropDownItem
              aria-label="Insert Variable"
              variables={variables}
              onAction={(action: string) => editor.chain().focus().insertNotification(action).run()}
              label="Insert Variable"
            />
          </Box>
        </>
      )}
    </Stack>
  );
}
